'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_config$TurnstileConfig(key) {
  this.Ks = null;
  this.Ks = key;
}
export { $c_Lpresto_config$TurnstileConfig as $c_Lpresto_config$TurnstileConfig };
$p = $c_Lpresto_config$TurnstileConfig.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_config$TurnstileConfig;
/** @constructor */
function $h_Lpresto_config$TurnstileConfig() {
}
export { $h_Lpresto_config$TurnstileConfig as $h_Lpresto_config$TurnstileConfig };
$h_Lpresto_config$TurnstileConfig.prototype = $p;
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_hashing_MurmurHash3$().S(this, (-889275714), false);
});
$p.i = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lpresto_config$TurnstileConfig) && (this.Ks === x$0.Ks)));
});
$p.l = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().H(this);
});
$p.r = (function() {
  return 1;
});
$p.s = (function() {
  return "TurnstileConfig";
});
$p.j = (function(n) {
  if ((n === 0)) {
    return this.Ks;
  }
  throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lpresto_config$TurnstileConfig(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.j8)));
}
export { $isArrayOf_Lpresto_config$TurnstileConfig as $isArrayOf_Lpresto_config$TurnstileConfig };
var $d_Lpresto_config$TurnstileConfig = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_config$TurnstileConfig, "presto.config$TurnstileConfig", ({
  j8: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lpresto_config$TurnstileConfig as $d_Lpresto_config$TurnstileConfig };
//# sourceMappingURL=presto.config$-Turnstile-Config.js.map
